import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS } from "../../../helper/constants";

const{ weather_radar } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;

const pageNameSessionStorage = "breadCrumbSearchResultPageName";

const useBreadcrumbData = () => {
  const navigate = useNavigate();
  const { subCategoryNameVirtualClassrooms, itemName, subCategoryNameEngines } = useSelector((state: any) => state?.virtualClassRoomsOrEngines);

  return { navigate, subCategoryNameVirtualClassrooms, itemName, subCategoryNameEngines };
};

interface BreadcrumbConfig {
    path: string;
    name: string;
  }
  
  const breadcrumbRoutes: BreadcrumbConfig[] = [
    { path: '/', name: 'Hangar' },
    { path: '/downloads', name: 'Downloads' },
    { path: '/favorites', name: 'Favorites' },
    { path: '/notifications', name: 'Notifications' },
    { path: '/subscriptions', name: 'Subscriptions' },
    { path: '/virtualclassrooms', name: 'Virtual classrooms' },
    { path: '/virtualclassroomsDetail', name: 'Virtual classrooms' },
    { path: '/virtualclassroomsDetailList', name: 'Virtual classrooms' },
    { path: '/engines', name: 'Engines' },
    { path: '/enginesList', name: 'Engines' },
    { path: '/viewcollection', name: 'Collection View' }, //param
    { path: '/temprevisions', name: 'Temporary Revisions' }, //param
    { path: '/relatedpub', name: 'Related Publications' }, //param
    { path: '/subscription_request', name: 'Subscription Request' }, //param
    { path: '/rev_request', name: 'Revision Request' },
    { path: '/hangardetailedview', name: 'Aircraft' },
  ];

  const addNewBreadcrumbItem = (  
    pathName: string, 
    index: number, 
    navigate: any, 
    subCategoryNameVirtualClassrooms: string, 
    itemName: string, 
    subCategoryNameEngines: string, 
    breadcrumbCurrentPageNameFromSessionStorage: any,
     handleBreadcrumbValidation: (navValue: string, onSuccess: () => void) => void
  ) => {
    let newItemText = "";

    if (breadcrumbCurrentPageNameFromSessionStorage && breadcrumbCurrentPageNameFromSessionStorage?.includes("/hangardetailedview")) {
      return (
        <>
          <li 
            className="breadcrumb-item" 
            onClick={() => { 
              const navTo = breadcrumbCurrentPageNameFromSessionStorage;
              handleBreadcrumbValidation(navTo, ()=>{ 
                navigate(navTo); 
                deleteBreadcrumbCurrentPageNameFromSessionStorage(); 
              }); 
            }}
          >
            <a>Aircraft</a>
          </li>
          <li className="breadcrumb-item">
          <a>...</a>
        </li>
       </>
      );
    }

    if(breadcrumbCurrentPageNameFromSessionStorage && breadcrumbCurrentPageNameFromSessionStorage === "/enginesList" || breadcrumbCurrentPageNameFromSessionStorage === "/virtualclassroomsDetailList"){
      const primaryPathObj = breadcrumbCurrentPageNameFromSessionStorage == "/enginesList" ? {path:"/engines", name:"Engines"} : {path:"/virtualclassrooms", name:"Virtual classrooms"};
      const subCategoryObj = breadcrumbCurrentPageNameFromSessionStorage == "/enginesList" ? {path:"/enginesList", name:subCategoryNameEngines} : {path:subCategoryNameVirtualClassrooms.toLowerCase() === weather_radar ? "/virtualclassroomsDetail" : "/virtualclassroomsDetailList", name:subCategoryNameVirtualClassrooms};
      const itemObj = itemName && breadcrumbCurrentPageNameFromSessionStorage == "/virtualclassroomsDetailList" ? {path:"/virtualclassroomsDetailList", name:itemName} : undefined;
      return ( 
        <>
         <li 
          className="breadcrumb-item" 
          onClick={()=>{
            const navTo = primaryPathObj.path;
            handleBreadcrumbValidation(navTo, ()=>{ 
              navigate(navTo); 
              deleteBreadcrumbCurrentPageNameFromSessionStorage(); 
            });
          }}
        >
          <a>{primaryPathObj.name}</a>
        </li>
        <li 
          className="breadcrumb-item" 
          onClick={()=>{ 
            const navTo = subCategoryObj.path;
            handleBreadcrumbValidation(navTo, ()=>{ 
              navigate(navTo); 
              deleteBreadcrumbCurrentPageNameFromSessionStorage(); 
            });
          }}
        >
          <a>{subCategoryObj.name}</a>
        </li>
        {itemObj && subCategoryNameVirtualClassrooms.toLowerCase() === weather_radar &&(
          <li 
            className="breadcrumb-item" 
            onClick={()=>{
              const navTo = itemObj.path;
              handleBreadcrumbValidation(navTo, ()=>{ 
                navigate(navTo); 
                deleteBreadcrumbCurrentPageNameFromSessionStorage(); 
              });
            }}
          >
           <a>{itemObj.name}</a>
          </li>
        )}
        <li className="breadcrumb-item">
           <a>...</a>
         </li>
        </>
      );
    }
        
    switch(pathName) {
      case "enginesList":
        newItemText = subCategoryNameEngines;
        break;
      case "virtualclassroomsDetail":
        newItemText = subCategoryNameVirtualClassrooms;
        break;
      case "virtualclassroomsDetailList":
        newItemText = itemName; 
        break;
    }
  
    if(newItemText){
      if(newItemText === itemName){
        return ( 
          <>
          <li className="breadcrumb-item" onClick={()=>{ subCategoryNameVirtualClassrooms.toLowerCase() === weather_radar && navigate("/virtualclassroomsDetail");}}>
            <a>{subCategoryNameVirtualClassrooms}</a>
          </li>
          {
            subCategoryNameVirtualClassrooms.toLowerCase() === weather_radar && (
              <li className="breadcrumb-item">
                <a>{newItemText}</a>
              </li>
            )    
          }
          
          </>
        );
      }
      return ( 
        <li className="breadcrumb-item active">
          {newItemText}
        </li>
      );
    }
    return null; 
  }; 
  

  const redirection = (to: string, name: string )=>{
    switch(name) {
      case "Virtual classrooms":
        return "/virtualclassrooms";
      case "Engines":
        return "/engines";
      default:
        return to;
    }
  };

  const addBreadcrumbCurrentPageNameToSessionStorage = () => {
    const breadCrumbSearchResultPageName = window.sessionStorage.getItem(pageNameSessionStorage) || undefined;
    if(breadCrumbSearchResultPageName == undefined){
      window.sessionStorage.setItem(pageNameSessionStorage, window.location.pathname);
    }
  };

  const deleteBreadcrumbCurrentPageNameFromSessionStorage = () => {
    const breadCrumbSearchResultPageName = window.sessionStorage.getItem(pageNameSessionStorage) || undefined;
    if(breadCrumbSearchResultPageName !== undefined){
      window.sessionStorage.removeItem(pageNameSessionStorage);
      window.sessionStorage.removeItem("pathNames");
    }
  };
  
  const handleOpenRequestPublicationModal = () => {
     const pathnames = location.pathname.split('/').filter((x) => x);
     if (pathnames.includes("subscription_request")) {
      return true;
     }
     return false;
  };

  export {
    breadcrumbRoutes,
    addNewBreadcrumbItem,
    useBreadcrumbData,
    redirection,
    addBreadcrumbCurrentPageNameToSessionStorage,
    deleteBreadcrumbCurrentPageNameFromSessionStorage,
    handleOpenRequestPublicationModal
  };